import { EventEmitter } from "@treefort/lib/event-emitter"

export type WindowDimensions = {
  width: number
  height: number
}

export enum WindowDimensionsEvent {
  Updated = "UPDATED",
  HeightUpdated = "HEIGHT_UPDATED",
  WidthUpdated = "WIDTH_UPDATED",
}

interface WindowDimensionsEventMap {
  [WindowDimensionsEvent.Updated]: WindowDimensions
  [WindowDimensionsEvent.HeightUpdated]: WindowDimensions
  [WindowDimensionsEvent.WidthUpdated]: WindowDimensions
}

export class WindowDimensionsStore extends EventEmitter<WindowDimensionsEventMap> {
  dimensions?: WindowDimensions
  suspendedDimensions?: WindowDimensions

  constructor(dimensions?: WindowDimensions) {
    super()
    this.dimensions = dimensions
  }

  private emitEvents(prevDimensions?: WindowDimensions) {
    // Do nothing if we're suspended
    if (this.suspendedDimensions || !this.dimensions) {
      return
    }

    const heightChanged =
      !prevDimensions ||
      Math.round(this.dimensions.height) !== Math.round(prevDimensions.height)
    const widthChanged =
      !prevDimensions ||
      Math.round(this.dimensions.width) !== Math.round(prevDimensions.width)

    if (heightChanged || widthChanged) {
      this.emitter.emit(WindowDimensionsEvent.Updated, this.dimensions)
    }
    if (heightChanged) {
      this.emitter.emit(WindowDimensionsEvent.HeightUpdated, this.dimensions)
    }
    if (widthChanged) {
      this.emitter.emit(WindowDimensionsEvent.WidthUpdated, this.dimensions)
    }
  }

  suspend = () => {
    if (!this.suspendedDimensions) {
      this.suspendedDimensions = this.dimensions
    }
  }

  resume = () => {
    if (this.suspendedDimensions) {
      const prevDimensions = this.suspendedDimensions
      this.suspendedDimensions = undefined
      this.emitEvents(prevDimensions)
    }
  }

  get = () => this.suspendedDimensions || this.dimensions

  set = (dimensions: WindowDimensions) => {
    const prevDimensions = this.dimensions
    this.dimensions = dimensions
    this.emitEvents(prevDimensions)
  }
}
